// @ts-nocheck
/* eslint-enable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import includes from 'lodash/includes';
import { withRouter } from 'react-router-dom';
import pathsManifest from 'app/shared/utils/pathsManifest';
import AuthActions from 'app/shared/flux/actions/AuthActions';

// const validRoles = ['user', 'verified', 'rep', 'admin'];
const hasRoleReq = (userRoles, roleReq) => {
  if (roleReq === 'user' && includes(userRoles, 'user')) {
    return true;
  } else if (roleReq === 'rep' && includes(userRoles, 'rep')) {
    return true;
  } else if (roleReq === 'admin' && includes(userRoles, 'admin')) {
    return true;
  }

  return false;
};

const RoleCheck = ({ roleReq, verifiedReq }) => {
  return (component) => {
    class RenderComponent extends Component {
      static serverRouteWillMount(reactContext) {
        const { store } = reactContext;
        const desiredPath = store.getState().location.current.pathname;

        return store.dispatch(AuthActions.login.info()).then((result) => {
          if (!result.data.loggedIn) {
            return {
              redirect: true,
              to: `${pathsManifest.LoginPage}?redirect=${desiredPath}`,
              changeHttpStatus: 302,
            };
          } else if (!hasRoleReq(result.data.roles, roleReq)) {
            // logged in. but does not have rolRequired ==> go to favorites page
            return {
              redirect: true,
              to: pathsManifest.ViewedItemsPage,
              changeHttpStatus: 302,
            };
          } else if (hasRoleReq(result.data.roles, roleReq) && verifiedReq && !result.data.creds.verified) {
            // is logged in. has roleRequired. page also requires verification
            // if user is not verified, must log in. so redirect to login page.
            return {
              redirect: true,
              to: `${pathsManifest.LoginPage}?redirect=${desiredPath}`,
              changeHttpStatus: 302,
            };
          } else if (component.serverRouteWillMount) {
            return component.serverRouteWillMount(reactContext);
          }
          return true;
        });
      }

      constructor(props) {
        super(props);
        if (__BROWSER__) {
          const { user, pathname } = this.props;
          if (!user.loggedIn) {
            window.router.redirectTo(`${pathsManifest.LoginPage}?redirect=${pathname}`);
          } else if (!hasRoleReq(user.info.roles, roleReq)) {
            // logged in. but does not have rolRequired ==> go to favorites page
            window.router.redirectTo(pathsManifest.MyListPage);
          } else if (hasRoleReq(user.info.roles, roleReq) && verifiedReq && !user.isVerified) {
            // is logged in. has roleRequired. page also requires verification
            // if user is not verified, must log in. so redirect to login page.
            window.router.redirectTo(`${pathsManifest.LoginPage}?redirect=${pathname}`);
          }
        }
      }

      render() {
        const { user } = this.props;
        const hasPermission =
          hasRoleReq(user.info.roles, roleReq) && (!verifiedReq || (verifiedReq && user.isVerified));

        if (hasPermission) {
          return React.createElement(component, { ...this.props });
        } else {
          return null;
        }
      }
    }

    const mapStateToProps = (state, ownProps) => ({
      pathname: ownProps.location.pathname,
      user: state.user,
    });

    return withRouter(connect(mapStateToProps)(RenderComponent));
  };
};

export default RoleCheck;
